import React, { useEffect, lazy, Suspense, useState } from 'react'
import { Route, Redirect, Switch } from 'react-router-dom'
import { ConnectedRouter } from 'connected-react-router'
import { history } from 'index'
import { CSSTransition, SwitchTransition } from 'react-transition-group'
import { connect } from 'react-redux'

import Layout from 'layouts'
import jwt from 'jsonwebtoken'

const routes = [
  // Activate Account Page
  {
    path: '/activate-account',
    Component: lazy(() => import('pages/activateAccount')),
    exact: true,
  },
  {
    path: '/activate-account/add-personal-information',
    Component: lazy(() => import('pages/activateAccount/personalInfoConfirmation')),
    exact: true,
  },
  {
    path: '/auth/screening-verification',
    Component: lazy(() => import('pages/idvScreening')),
    exact: true,
  },
  {
    path: '/auth/screening/verfiy-identity',
    Component: lazy(() => import('pages/idvScreening/documents/document')),
    exact: true,
  },
  {
    path: '/auth/screening/verfiy-selfie',
    Component: lazy(() => import('pages/idvScreening/documents/selfie')),
    exact: true,
  },
  {
    path: '/auth/screening/upload-documents',
    Component: lazy(() => import('pages/idvScreening/documents/manualUpload')),
    exact: true,
  },
  {
    path: '/auth/screening/upload-response',
    Component: lazy(() => import('pages/idvScreening/documents/screeningResponse')),
    exact: true,
  },

  // Dashboards
  {
    path: '/dashboard/alpha',
    Component: lazy(() => import('pages/dashboard/alpha')),
    exact: true,
  },
  {
    path: '/dashboard/beta',
    Component: lazy(() => import('pages/dashboard/beta')),
    exact: true,
  },
  {
    path: '/dashboard/gamma',
    Component: lazy(() => import('pages/dashboard/gamma')),
    exact: true,
  },
  {
    path: '/dashboard/crypto',
    Component: lazy(() => import('pages/dashboard/crypto')),
    exact: true,
  },

  // Auth Pages
  {
    path: '/auth/register',
    Component: lazy(() => import('pages/auth/register')),
    exact: true,
  },
  {
    path: '/auth/login',
    Component: lazy(() => import('pages/auth/login')),
    exact: true,
  },
  {
    path: '/auth/forgot-password',
    Component: lazy(() => import('pages/auth/forgot-password')),
    exact: true,
  },
  {
    path: '/auth/lockscreen',
    Component: lazy(() => import('pages/auth/lockscreen')),
    exact: true,
  },
  {
    path: '/auth/404',
    Component: lazy(() => import('pages/auth/404')),
    exact: true,
  },
  {
    path: '/auth/500',
    Component: lazy(() => import('pages/auth/500')),
    exact: true,
  },

  // auth0
  {
    path: '/auth/setup-2fa',
    Component: lazy(() => import('pages/auth/auth0/setup2fa')),
    exact: true,
  },
  {
    path: '/auth/2fa-code-validation',
    Component: lazy(() => import('pages/auth/login/codeValidation')),
    exact: true,
  },

  // existing platform urls

  {
    path: '/user-profile',
    Component: lazy(() => import('pages/settings/profile')),
    exact: true,
  },

  // {
  //   path: '/auth/personal-details',
  //   Component: lazy(() => import('pages/auth/register/personalDetails')),
  //   exact: true,
  // },
  // manage deposits

  {
    path: '/trades',
    Component: lazy(() => import('pages/manageDeposits/trades')),
    exact: true,
  },
  {
    path: '/new-trade',
    Component: lazy(() => import('pages/manageDeposits/newTrade')),
    exact: true,
  },
  {
    path: '/trade',
    Component: lazy(() => import('pages/manageDeposits/trade')),
    exact: true,
  },
  {
    path: '/reports',
    Component: lazy(() => import('pages/manageDeposits/reports')),
    exact: true,
  },
  {
    path: '/account-balances',
    Component: lazy(() => import('pages/currencyAccounts/clientBalances')),
    exact: true,
  },
  {
    path: '/account-balance/account-summary/:id',
    Component: lazy(() => import('pages/currencyAccounts/transactions')),
    exact: true,
  },
  {
    path: '/new-payment',
    Component: lazy(() => import('pages/digitalPayment')),
    exact: true,
  },
  {
    path: '/new-payment-success',
    Component: lazy(() => import('pages/digitalPayment/successPage')),
  },

  // privacy and policies pages
  {
    path: '/auth/privacy-policy',
    Component: lazy(() => import('components/customComponents/policePages/privacyPolicy')),
    exact: true,
  },
  {
    path: '/auth/terms-of-services',
    Component: lazy(() => import('components/customComponents/policePages/termsOfServices')),
    exact: true,
  },
]

const mapStateToProps = ({ settings, user }) => ({
  routerAnimation: settings.routerAnimation,
  token: user.token,
})

const Router = ({ token, routerAnimation }) => {
  const [idvScreeningUel] = useState('/auth/screening-verification')
  useEffect(() => {
    const screeningUrl = history.location.pathname === idvScreeningUel
    if (!screeningUrl) {
      logoutOnTokenExpire(token)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const logoutOnTokenExpire = JwtToken => {
    if (JwtToken) {
      const decodeToken = jwt.decode(JwtToken)
      const tokenExpireAt = decodeToken.exp
      const currentTime = (new Date().getTime() + 1) / 1000
      if (currentTime >= tokenExpireAt) {
        history.push('/auth/login')
      } else {
        const setTime = (tokenExpireAt - currentTime) * 1000
        setTimeout(() => {
          history.push('/auth/login')
        }, setTime)
      }
    }
  }
  return (
    <ConnectedRouter history={history}>
      <Layout>
        <Route
          render={state => {
            const { location } = state
            return (
              <SwitchTransition>
                <CSSTransition
                  key={location.pathname}
                  appear
                  classNames={routerAnimation}
                  timeout={routerAnimation === 'none' ? 0 : 300}
                >
                  <Switch location={location}>
                    <Route exact path="/" render={() => <Redirect to="/activate-account" />} />
                    {routes.map(({ path, Component, exact }) => (
                      <Route
                        path={path}
                        key={path}
                        exact={exact}
                        render={() => {
                          return (
                            <div className={routerAnimation}>
                              <Suspense fallback={null}>
                                <Component />
                              </Suspense>
                            </div>
                          )
                        }}
                      />
                    ))}
                    <Redirect to="/auth/404" />
                  </Switch>
                </CSSTransition>
              </SwitchTransition>
            )
          }}
        />
      </Layout>
    </ConnectedRouter>
  )
}

export default connect(mapStateToProps)(Router)
